import { directionLabel } from "../api/format";

export function LiveBadge({ live }: { live: boolean }) {
  return live ? <span className="pill pill-ok">live</span> : <span className="pill pill-muted">not pinging</span>;
}

export function DirectionBadge({ direction }: { direction: string | null | undefined }) {
  return <span className="pill">{directionLabel(direction)}</span>;
}
